import {Component} from "react";
import visitor_logo from "../../../assets/img/logos/visitor_logo.png";
import React from "react";
import * as routeConstants from "../../../const/route/Route";
import './ThankYou.scss';
import * as actionCreator from "../../../store/Action";
import {connect} from "react-redux";

/**
 * Created by WebStorm.
 * User: athukorala
 * Date: 10/28/20
 * Time: 3:40 PM
 */
class App extends Component {
  state = {
    corporateName: "",
    corporatePhotoPath: ""
  };
  componentWillMount() {
    let state = this.props.location.state;
    if (state === undefined) {
      this.props.history.push(`${routeConstants.GUEST_ROUTE_PATH}/login`);
    } else {
      this.setState({corporateName: state.corporateName, corporatePhotoPath: state.corporatePhotoPath})
    }
    this.props.setGuestUserDetails({
      guestIsLogin:null,branchId:null,guestStatus:null,pinRequired: false
    });
  }
  render() {
    let {corporateName, corporatePhotoPath} = this.state;
    return (
      <div className={"public-thank-you"}>
        <div className={"sub-modal"}>

          <p className={"first"}>
            {`${corporateName ? `Thank you for visiting ${corporateName}.`:`Thank you`}`}
          </p>
          <div className={"success-modal-img-wrapper"}>
            {corporatePhotoPath !== null && corporatePhotoPath !== "" ? <img src={corporatePhotoPath} alt={"."} className={"thankyou-img"}/> : null}
            <img src={visitor_logo} alt={"."} className={"thankyou-img"}/>
          </div>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    // guest user reducer
    setGuestUserDetails: (data) => dispatch(actionCreator.setGuestUserDetails(data)),
  };
};

export default connect(null, mapDispatchToProps)(App);
